import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        courseVersions: '=',
        sites: '=',
        saveErrors: '<'
    },
    template: `
        <div>
             <courses-courses-edit-occurrence-automated-planning-group-steps-general
                planning-group="vm.planningGroup"
                course-versions="vm.courseVersions"
                sites="vm.sites"
                save-errors="vm.saveErrors"
                context="'edit'"
            />
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/edit/general/index.js